import { func, shape } from 'prop-types';
import React from 'react';
import { Alert, Col, Label, Row } from 'reactstrap';

import MultiSelect from '../../generic/MultiSelect';
import TagInput from '../../generic/TagInput';
import { campaignShape, highlightedSkusShape } from '../../prop-types';
import { COLORS } from '../../utils/constants';

function RefreshSKUForm({ campaign, value, onChange }) {
  const { availableProducts, selectedProducts } = value;

  if (!availableProducts.length) {
    return (
      <Alert color={COLORS.WARNING}>
        This campaign does not have any products that support highlighted SKUs
      </Alert>
    );
  }

  return (
    <div className="mb-5">
      <Row className="mb-4">
        <Label sm={2}>Select product</Label>
        <Col sm={10}>
          <MultiSelect
            options={availableProducts}
            value={selectedProducts}
            onChange={onChange}
            name="selectedProducts"
          />
        </Col>
      </Row>
      {!!selectedProducts.length && (
        <Row className="mb-3 font-weight-semi-bold">
          <Col sm={2} />
          <Col sm={5}>Current</Col>
          <Col sm={5}>New</Col>
        </Row>
      )}
      {selectedProducts.map(productCode => {
        const oldSkus = campaign.highlightedSkus[productCode];
        const newSkus = value.highlightedSkus[productCode] || [];
        const productLabel = availableProducts.find(
          p => p.value === productCode,
        ).label;

        return (
          <div key={productCode}>
            <Row
              className="mb-2 align-items-center"
              key={`skus-${productCode}`}
            >
              <Col sm={2}>
                <span className="text-nowrap">{productLabel}</span>
              </Col>
              <Col sm={5}>
                <span id={`current-sku-${productCode}`}>
                  {oldSkus && oldSkus.length ? oldSkus.join(', ') : 'N/A'}
                </span>
              </Col>
              <Col sm={5} className={`${productCode}-CR`}>
                <TagInput
                  id={`new-sku-${productCode}`}
                  name={`highlightedSkus.${productCode}`}
                  value={newSkus}
                  onChange={onChange}
                  isSkuInput
                />
              </Col>
            </Row>
            {newSkus.length < 25 && (
              <Row key={`alert-${productCode}`}>
                <Col sm={2} />
                <Col sm={10}>
                  <Alert color={COLORS.WARNING}>
                    For product &quot;{productCode}&quot; we recommend adding a
                    minimum of 25 SKUs in order to improve the performance of
                    the Campaign.
                  </Alert>
                </Col>
              </Row>
            )}
          </div>
        );
      })}
    </div>
  );
}

RefreshSKUForm.propTypes = {
  onChange: func.isRequired,
  value: shape({
    highlightedSkus: highlightedSkusShape.isRequired,
  }).isRequired,
  campaign: campaignShape.isRequired,
};

export default RefreshSKUForm;
